const initialState = {
    tal: {singleday_wdata: null, multiday_wdata: null},
    berg: {singleday_wdata: null, multiday_wdata: null},    
    active_tab: 'tal'
};

export default function wetterReducer(state = initialState, action) {
    switch (action.type) {
        case "SET_SINGLE_WDATA_TAL":            
            return {
                ...state,
                tal: {...state.tal, singleday_wdata: action.payload}
            };
        case "SET_SINGLE_WDATA_BERGE":
            return {
                ...state,
                berg: {...state.berg, singleday_wdata: action.payload}
            };
        case "SET_MULTI_WDATA_TAL":
            return {
                ...state,
                tal: {...state.tal, multiday_wdata: action.payload}
            };
        case "SET_MULTI_WDATA_BERGE":
            return {
                ...state,
                berg: {...state.berg, multiday_wdata: action.payload}
            };
        case "SET_ACTIVE_TAB":
            return {
                ...state,
                active_tab: action.payload
            };        
        default:
            return state;
    }
}